import { render, staticRenderFns } from "./PushPop.vue?vue&type=template&id=649bec80&scoped=true&"
import script from "./PushPop.vue?vue&type=script&lang=js&"
export * from "./PushPop.vue?vue&type=script&lang=js&"
import style0 from "./PushPop.vue?vue&type=style&index=0&id=649bec80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649bec80",
  null
  
)

export default component.exports